import { sendRequest } from '.';
import { IConstants } from '../types/constants';
import { IState } from '../types/general';

export const getConstantsApi = () => {
  return sendRequest<IConstants>({
    requestType: 'getConstants',
  });
};

export const getStateApi = () => {
  return sendRequest<IState>({
    requestType: 'getState',
  });
};
